import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { routePaths } from '../../../../../routes/routeConstants'
import { handleAddToCart } from '../../../../Desktop/Pages/Cart/cartFunctions'
import { truncateHTML } from '../../../../../utils/functions'
import CustomToast from '../../../../../customComponents/CustomToast'
import useToast from '../../../../../customComponents/CustomUseToast'

export const MobileNonDigitalProductsListingCard = ({ product, user }) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { toastOpen, toastMessage, toastSeverity, showToast, closeToast } = useToast()

	const handleAddToCartForProduct = useCallback(
		(e) => {
			e.preventDefault()
			if (!user) {
				showToast('Customer must Sign Up to purchase products', 'error')
				setTimeout(() => {
					navigate(routePaths?.signIn)
				}, 1000)
			} else {
				handleAddToCart(e, product, dispatch)
			}
		},
		[product, dispatch, user, navigate, showToast]
	)

	return (
		<div className='card h-100 border rounded-3 shadow-sm'>
			{' '}
			{/* Added consistent card styling */}
			<div className='position-relative'>
				{product.salarChoice && <div className='ribbon-mobile ms-2 position-absolute start-0 top-0 z-1'>Salar Choice</div>}
				<Link to={`/non-digital-product-details/${product._id}`}>
					<img
						src={`${process.env.REACT_APP_RESOURCE_URL}${product.productImageUrl}`}
						alt={product.name}
						className='w-100 rounded-top'
						style={{
							height: '200px', // Reduced height
							maxHeight: '100%',
							objectFit: 'cover',
							objectPosition: 'center',
						}}
						loading='lazy'
					/>
				</Link>
			</div>
			<div className='card-body p-2'>
				{' '}
				{/* Reduced padding */}
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					{product?.unitValue && (
						<span className=' badge-info fw-bolder text-lowercase text-xxs p-1 text-black'>
							<small>{product.unitValue}</small>{' '}
						</span>
					)}
					{product?.ratings?.averageRating && product?.ratings?.averageRating !== 0 && (
						<span className='badge badge-pink badge-xs text-xs text-white'>
							<small>
								{product?.ratings?.averageRating} <i class='bi bi-star-fill'></i>
							</small>{' '}
							&nbsp;|&nbsp; <small>{product?.ratings?.totalCount}</small>
						</span>
					)}
				</div>
				<div className='mb-1'>
					<Link to={`/non-digital-product-details/${product._id}`} className='text-decoration-none'>
						<h6 className='text-black mb-0 text-truncate'>{product.name}</h6>
					</Link>
				</div>
				<div
					className='text-black-50 small mb-2'
					style={{
						height: '20px',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
					}}
				>
					{truncateHTML(product.description || '', 50)}
				</div>
				<div className='d-flex align-items-center mb-2'>
					<span className='text-black'>
						<span className='small'>₹</span>
						<span className='fw-bold'>{product.finalPrice}</span>
					</span>
				</div>
				<button className='btn btn-yellow btn-sm w-100' onClick={handleAddToCartForProduct}>
					Add to cart
				</button>
			</div>
			{toastOpen && <CustomToast open={toastOpen} message={toastMessage} severity={toastSeverity} onClose={closeToast} />}
		</div>
	)
}
